import React, { useState } from "react";
import axios from "axios"; // Import Axios for making HTTP requests

export default function DeleteUrl() {
  const [fileUrl, setFileUrl] = useState("");
  const [message, setMessage] = useState("");

  const handleDelete = async () => {
    try {
      const response = await axios.delete("/api/delete-file", {
        data: { fileUrl },
      });
      setMessage(response.data.message);
    } catch (error) {
      setMessage("Error deleting file from S3");
      console.error("Error deleting file from S3:", error);
    }
  };

  const handleChange = (e) => {
    setFileUrl(e.target.value);
  };

  return (
    <div>
      <h2>Delete File from S3</h2>
      <div>
        <label htmlFor="fileUrl">File URL:</label>
        <input
          type="text"
          id="fileUrl"
          name="fileUrl"
          value={fileUrl}
          onChange={handleChange}
        />
      </div>
      <button onClick={handleDelete}>Delete File</button>
      {message && <p>{message}</p>}
    </div>
  );
}
